import { Component, Inject, PropSync, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { CustomerTypeResponse } from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.dto'
import { customerTypesService } from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.service'
import { CustomerGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.dto'
import { customerGroupsService } from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.service'
import { PromiseUtils } from '@/shared/util/promise-utils'

@Component
export default class BillingModalCustomerCreationBasicForm extends Vue {
    @PropSync('customer', { type: Object }) readonly syncedCustomer!: Partial<CustomerResponse>

    @Inject() externalValidator!: Validator

    constructor() {
        super()
        this.$validator = this.externalValidator
    }

    async getCustomerTypes(): Promise<CustomerTypeResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response =
            await PromiseUtils.toCallSecure(
                customerTypesService.paginator(undefined, params))
        return response?.content ?? []
    }

    async getCustomerGroups(): Promise<CustomerGroupResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response =
            await PromiseUtils.toCallSecure(
                customerGroupsService.paginator(undefined, params))
        return response?.content ?? []
    }
}
